import { render, staticRenderFns } from "./YourDashboard.vue?vue&type=template&id=ceb4f374&scoped=true"
import script from "./YourDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./YourDashboard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./YourDashboard.vue?vue&type=style&index=0&id=ceb4f374&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceb4f374",
  null
  
)

export default component.exports